import { render, staticRenderFns } from "./PatientRecordForm.vue?vue&type=template&id=509ca6ec&scoped=true"
import script from "./PatientRecordForm.vue?vue&type=script&lang=js"
export * from "./PatientRecordForm.vue?vue&type=script&lang=js"
import style0 from "./PatientRecordForm.vue?vue&type=style&index=0&id=509ca6ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509ca6ec",
  null
  
)

export default component.exports